// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"fd8fdebd","95":"1ace8903","134":"38787e6a","149":"6f9c73ab","249":"87f0e802","341":"1bcb1036","662":"8c96269b","817":"b0061ea9","845":"c22e078a"}[chunkId] + ".chunk.js";
};